module.exports = __webpack_public_path__ + "static/media/food.f464e33b.jpg";